import { getOuterUrl } from '@wix/communities-blog-client-common';

export const getInternalLinkRoute = ({ topology, to, shouldNavigateToFeed, isSite }) => {
  const { baseUrl, isHomePage, sectionUrl: feedSectionUrl, postPageSectionUrl } = topology;
  const path = to === '/' ? '' : to;
  const basePath = isSite ? path : baseUrl;
  const sectionUrl = shouldNavigateToFeed
    ? path === '' && isHomePage
      ? basePath
      : feedSectionUrl
    : postPageSectionUrl;

  return getOuterUrl(path, sectionUrl);
};
